/** Motion presets. Durations are milliseconds. */
export const AppMotion = {
  spring: {
    subtle: {
      damping: 22,
      stiffness: 250,
      mass: 0.82,
    },
  },
  timing: {
    fast: 175,
  },
} as const;
